import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/sales-order", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/sales-order/csv", params);
};

const upsert = data => {
  return restApi.post("/api/sales-order/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/sales-order/${ids}`);
};

const salesOrderService = {
  getAll,
  getAllForCSV,
  upsert,
  remove
};

export default salesOrderService;